import React from 'react';

type CertavueProps = React.HTMLAttributes<HTMLSpanElement> & {
    fontSize?: string;
    style?: React.CSSProperties;
};

const Certavue: React.FC<CertavueProps> = ({
    fontSize = '2rem',
    style,
    ...props
}) => {
    return (
        <span
            style={{
                fontSize,
                fontWeight: 'bold',
                ...style
            }}
            {...props}
        >
            <span className="logo-certa text-moon-raker">certa</span>
            <span className="logo-vue text-fountain-blue">vue</span>
        </span>
    );
};

export default Certavue;
